import m from 'messages';
import alertActions from 'areas/alert/actions';
import swipeTypes from 'areas/swipes/domain/swipeTypes';
import repository from 'client/repository';

import progressActions from 'areas/progress/actions';

import {
    hideMultipleMatchesDialog,
    receiveManualLookup,
    requestManualLookupFailed,
    hideManualLookupDialog,
    showManualLookupDialog
} from '../actions';

import {
    requestCardData,
    receiveCardData,
    showCardholderPage
} from 'areas/cards/actions';


export default function (match, context) {
    return async dispatch => {
        try {
            dispatch(hideManualLookupDialog());
            dispatch(receiveManualLookup(match))

            // Signal and do the load of the card data
            dispatch(requestCardData(match.qrCode));
            dispatch(progressActions.report(m.cards.fetchingCard));

            const qrData = await repository.cards.getCardDataByQR(match.qrCode, true, true);
            qrData.cardData.swipeType = swipeTypes.Manual;
            qrData.cardData.dateRetrieved = new Date().toISOString();

            // Signal the card data has been received
            dispatch(receiveCardData(match.qrCode, qrData));

            dispatch(hideMultipleMatchesDialog());

            dispatch(showCardholderPage(match.qrCode, context));

            dispatch(progressActions.hide());
        } catch (e) {
            dispatch(requestManualLookupFailed(m.cards.noMatchFound));
            dispatch(progressActions.hide());
            dispatch(alertActions.warn(m.cards.noMatchFoundWarning));
            dispatch(showManualLookupDialog(context));
        }
    };
}